import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Select or remove origin order")])]), _c(VCardText, [_c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Order",
      items: _vm.listOrders,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "reference_order",
      "item-value": "id_order",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.initialOrderId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "initialOrderId", $$v);
      },
      expression: "form.initialOrderId"
    }
  })], 1)]), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isValidating
    },
    nativeOn: {
      click: function click($event) {
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_vm._v(" Confirm ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };